// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coach-eval-roster {
  margin-top: 20px;
}

.coach-eval-roster__hint,
.coach-eval-roster__empty {
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--text-secondary, #94a3b8);
}

.coach-eval-roster__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.coach-eval-roster__row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

.coach-eval-roster__row.is-current {
  border-color: rgba(8, 119, 188, 0.55);
}

.coach-eval-roster__who {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 140px;
}

.coach-eval-roster__who strong {
  font-size: 14px;
}

.coach-eval-roster__drill,
.coach-eval-roster__auto {
  font-size: 12px;
  color: var(--text-secondary, #94a3b8);
}

.coach-eval-roster__rate {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.coach-eval-roster__stars {
  display: flex;
  align-items: center;
}

.coach-eval-roster__star-btn {
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  line-height: 0;
}

.coach-eval-roster__star {
  color: rgba(255, 255, 255, 0.28);
  font-size: 22px;
}

.coach-eval-roster__star.is-on {
  color: #fbbf24;
}

.coach-eval-roster__notes {
  min-width: 160px;
  flex: 1 1;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(0, 0, 0, 0.2);
  color: inherit;
  font-size: 13px;
}

.coach-eval-roster__save {
  border: 0;
  border-radius: 6px;
  padding: 8px 12px;
  background: #fbbf24;
  color: #111;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
}

.coach-eval-roster__save:disabled {
  opacity: 0.55;
  cursor: default;
}

.coach-eval-roster__error {
  margin: 8px 0 0;
  color: #f87171;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CoachExerciseEvalRoster.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB","sourcesContent":[".coach-eval-roster {\n  margin-top: 20px;\n}\n\n.coach-eval-roster__hint,\n.coach-eval-roster__empty {\n  margin: 0 0 12px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--text-secondary, #94a3b8);\n}\n\n.coach-eval-roster__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.coach-eval-roster__row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.coach-eval-roster__row.is-current {\n  border-color: rgba(8, 119, 188, 0.55);\n}\n\n.coach-eval-roster__who {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 140px;\n}\n\n.coach-eval-roster__who strong {\n  font-size: 14px;\n}\n\n.coach-eval-roster__drill,\n.coach-eval-roster__auto {\n  font-size: 12px;\n  color: var(--text-secondary, #94a3b8);\n}\n\n.coach-eval-roster__rate {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.coach-eval-roster__stars {\n  display: flex;\n  align-items: center;\n}\n\n.coach-eval-roster__star-btn {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  line-height: 0;\n}\n\n.coach-eval-roster__star {\n  color: rgba(255, 255, 255, 0.28);\n  font-size: 22px;\n}\n\n.coach-eval-roster__star.is-on {\n  color: #fbbf24;\n}\n\n.coach-eval-roster__notes {\n  min-width: 160px;\n  flex: 1;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(0, 0, 0, 0.2);\n  color: inherit;\n  font-size: 13px;\n}\n\n.coach-eval-roster__save {\n  border: 0;\n  border-radius: 6px;\n  padding: 8px 12px;\n  background: #fbbf24;\n  color: #111;\n  font-weight: 700;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.coach-eval-roster__save:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.coach-eval-roster__error {\n  margin: 8px 0 0;\n  color: #f87171;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
